import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Tabs, Tab } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { ParticipantForm } from './ParticipantForm';
import Iconify from '../../../../../components/Iconify';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose } = props;
  const [currentTab, setCurrentTab] = React.useState(0);

  return (
    <Scrollbar>
      {/* <Box sx={{ mb: 2, width: '30%' }}>
        <Tabs sx={{ ml: 1 }} value={currentTab} onChange={(e, value) => setCurrentTab(value)}>
          <Tab label="zamówienie" icon={<Iconify icon={'ic:round-account-box'} width={20} height={20} />} />
          <Tab label="dane rezerwacji" icon={<Iconify icon={'ic:round-account-box'} width={20} height={20} />} />
        </Tabs>
      </Box> */}
      { currentTab === 0
        ? <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
          <Stack flex="1 1 70%">
            <Card>
              <CardHeader title={data ? 'Edytuj uczestnika' : 'Dodaj uczestnika'} sx={{ mt: -1, mb: -2 }} />
              <CardContent>
                <ParticipantForm data={data} submitCallback={submitCallback} handleClose={handleClose} />
              </CardContent>
            </Card>
          </Stack>
        </Box>
        : <Box>asd</Box>}
    </Scrollbar>
  );
};
